import { computed, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MemberStore } from '../../store/member/member.store';
import { filter, map, of, take } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export const getMemberByIdResolver: ResolveFn<any> = (route, state) => {
  const memberStore = inject(MemberStore)
  const member_id = Number(route.params['member_id'])
  if(typeof member_id === 'number' && Number.isFinite(member_id)) {
      memberStore.setMemberId(member_id)
  }
  memberStore.getMemberById()

  return toObservable(
    computed(() => ({
      status: memberStore.memberLoadingStatus(),
    }))
  ).pipe(
    filter(({status}) => status === 'success' || status === 'error'),
    take(1),
    map(({ status }) => status)
  )
};
